import { Button, CircularProgress, InputBase, Modal, Typography, Backdrop } from "@mui/material";
import KwilDB from "kwildb";
import { useState } from "react";
import TableInputs from "./TableInputs";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { useDispatch, useSelector } from "react-redux";
import { removeColumn, removeVarType, resetNewTable } from "../../../../redux/slices/newTableSlice";
import PrimaryKeyColumn from "./PrimaryKeyColumn";

export default function NewTableCreation({ addTable, setAddTable, setError, privKey, loadedMoat, secret, name, setSuccess }) {
    const [newTable, setNewTable] = useState("")
    const [loadAddTable, setLoadAddTable] = useState(false)
    const [colAmount, setColAmount] = useState([1, 1])
    const masterName = useSelector((state) => state?.newTable.columnName)
    const masterType = useSelector((state) => state?.newTable.varType)

    const [submit, setSubmit] = useState(0)

    const dispatch = useDispatch()
    
    function createMasterString() {
        let tableString = ""
        for(let i = 0; i < masterName.length; i++) {
            tableString += masterName[i] + " " + masterType[i] + ", "
        }
        return tableString.slice(0, -2)
    }

    function checkEmpty() {
        return masterName.some(input => input === "" || input === null || input === undefined) || masterType.some(input => input === "" || input === null || input === undefined)
    }

    function containDuplicates() {
        for (let i = 0; i < masterName.length; i++) {
            if (masterName.includes(masterName[i], i + 1)) {
                return true
            } else {
                return false
            }
        }
    }

    function createTable(e) {
        if (checkEmpty()) {
            setError("All fields are required. You can use the minus button to remove uneeded columns.")
        } else if (containDuplicates()) {
            setError("All column names must be unique.")
        } else if(colAmount.length < 1) {
            setError("At lease one column is required.")
        } else {
            e.preventDefault()
            const tableString = createMasterString()
            setLoadAddTable(true)
            setTimeout(async function () {
                const kwilDB = KwilDB.createConnector(
                    {
                        host: "test-db.kwil.xyz",
                        protocol: "https",
                        port: null,
                        moat: loadedMoat,
                        privateKey: JSON.parse(privKey)
                    },
                    secret
                )
                await kwilDB.query(`CREATE TABLE ${name}.${newTable}(${tableString})`, true)
                setLoadAddTable(false)
                setAddTable(false)
                window.location.reload(true)
            })   
        }
    }

    function addCol() {
        setColAmount([1].concat(colAmount))
    }

    function removeCol() {
        setColAmount(colAmount.slice(0, -1))
    }

    return(
        <Modal
            open={addTable}
            onClose={() => {
                setAddTable(false)
                dispatch(resetNewTable())
            }}
            sx={{ display: "flex"}}
        >
            <div className="modal-intro moat">
                <p className="modal-title">Create New Table</p>
                <Scrollbars
                    autoHeight
                    autoHeightMin={360}
                    autoHeightMax={700}
                >
                    <div style={{ display: "grid" }}>
                        <Typography
                            sx={{
                                margin: "22px 28px 0px",
                                color: "#fff",
                                fontFamily: "Averta",
                                fontWeight: "400" }}>
                            Table Name
                        </Typography>
                        <InputBase
                            value={newTable}
                            placeholder={"New Table Name"}
                            sx={{
                                backgroundColor: "#040417",
                                color: "#fff",
                                borderRadius: "9px",
                                pl: "10px",
                                minHeight: "45px",
                                margin: "5px 28px",
                                border: "1px solid #114BA3",
                                fontFamily: "Averta",
                            }}
                            hiddenLabel={true}
                            id="outlined-basic"
                            varian="filled"
                            label=""
                            onChange={(e) => setNewTable(e.target.value.replace(/[^a-zA-Z0-9_ ]/g, '').replace(" ", "_").replace(/^[^a-zA-Z]/, ''))}
                        />
                    </div>
                    <PrimaryKeyColumn
                        setError={setError}
                        submit={submit
                        }
                    />
                    {colAmount.map((colName, index) => {
                        return(
                            <TableInputs
                                submit={submit}
                                index={index}
                                setError={setError}
                            />
                        )
                    })}
                    <div className="add-col-button">
                        <Button
                            sx={{
                                background: "linear-gradient(90deg, #118EA0 0%, #50C9DB 100%)",
                                borderRadius: "10px",
                                opacity: "0.9",
                            }}
                            onClick={addCol}
                        >
                            <AddIcon
                                sx={{
                                    color: "#fff",
                                }}
                            />
                        </Button>
                        <Button
                            sx={{
                                background: "linear-gradient(90deg, #118EA0 0%, #50C9DB 100%)",
                                borderRadius: "10px",
                                opacity: "0.9",
                                marginLeft: "19px"
                            }}
                            onClick={removeCol}
                        >
                            <RemoveIcon
                                sx={{
                                    color: "#fff",
                                }}
                            />
                        </Button>
                    </div>
                    <div style={{ display: "flex" }}>
                        <Button
                            sx={{
                                margin: "auto",
                                width: "19.027vw",
                                height: "38.72px",
                                background: "linear-gradient(90deg, #118EA0 0%, #50C9DB 100%)",
                                opacity: "0.9",
                                borderRadius: "9px",
                                fontFamily: "Averta",
                                fontWeight: "400",
                                fontSize: "20px",
                                lineHeight: "24px",
                                color: "#fff",
                                textTransform: "none",
                                marginBottom: "37.28px"
                            }}
                            onClick={(e) => {
                                if(newTable === "") {
                                    setError("Table Name cannot be blank!")
                                } else {

                                    createTable(e)
                                }
                            }}
                            onMouseEnter={() => {
                                dispatch(resetNewTable())
                                dispatch(removeColumn(""))
                                dispatch(removeVarType(""))
                                setSubmit(submit + 1)
                            }}
                        >
                            Submit
                        </Button>
                    </div>
                </Scrollbars>
                <Backdrop sx={{ display: "flex", flexDirection: "column" }} open={loadAddTable}>
                    <CircularProgress sx={{ color: "linear-gradient(90deg, #118EA0 0%, #50C9DB 100%)" }}/>
                </Backdrop>
            </div>
        </Modal>
    )
}